import { LOANREQUEST_BUCKETS, ORGANIZATIONS, USER_ROLES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUserCommon } from './userCommon';
import { schemaId } from '../../utils/schema.utils';

export const schemaAdviser = z
    .object({
        assignable: z.boolean().default(false),
        buckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        organization: z.nativeEnum(ORGANIZATIONS),
        ownedBuckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        role: z.literal(USER_ROLES.adviser),
        // deprecated: legacy assignment field, group membership lives on the group aggregates
        teamLeaderId: schemaId.optional(),
    })
    .merge(schemaUserCommon);
